import React from 'react';
import { Users, BookOpen, BarChart3, User } from 'lucide-react';

export const MenuDebugPage: React.FC = () => {
  const navItems = [
    { path: '/teach/students', label: '学生列表', icon: Users },
    { path: '/teach/classes', label: '班级管理', icon: BookOpen },
    { path: '/teach/learning-management', label: '习题制作', icon: BarChart3 },
    { path: '/teach/ability', label: '学生能力画像', icon: User, disabled: true },
  ];

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">菜单配置调试页面</h1>
      
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold mb-4">当前菜单配置：</h2>
        
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b">
              <th className="text-left p-2">序号</th>
              <th className="text-left p-2">标签</th>
              <th className="text-left p-2">路径</th>
              <th className="text-left p-2">禁用状态</th>
            </tr>
          </thead>
          <tbody>
            {navItems.map((item, index) => (
              <tr key={index} className="border-b">
                <td className="p-2">{index + 1}</td>
                <td className="p-2">{item.label}</td>
                <td className="p-2 font-mono text-sm">{item.path}</td>
                <td className="p-2">
                  {item.disabled ? (
                    <span className="text-red-600 font-semibold">是 ❌</span>
                  ) : (
                    <span className="text-green-600 font-semibold">否 ✅</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="mt-6 p-4 bg-blue-50 rounded">
          <h3 className="font-semibold mb-2">习题制作菜单详情：</h3>
          <pre className="text-sm">{JSON.stringify(navItems[2], null, 2)}</pre>
        </div>

        <div className="mt-4 p-4 bg-gray-50 rounded">
          <h3 className="font-semibold mb-2">完整配置：</h3>
          <pre className="text-xs overflow-auto">{JSON.stringify(navItems, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
};
